//
import moment from 'moment'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import CurrencyUtils from '@/mixins/reusable_mixins/CurrencyUtils'

//
import CustomerReceivablePaymentService from '@/services/api/pos/customer-receivable-payment'
import BankModel from '@/models/General/GBank'

const fetchBank = async function() {
    return (await BankModel.params({
        get_all_results: true,
    }).get()).data
}

const searchBankName = function(arr, id) {
    let bank = arr.find(r => r.id === id)
    return bank.bank
}

const getTypeCheck = function(id) {
    if (id === 1) {
        return 'Cheque a Fecha'
    }
    return 'Cheque al día'
}

const setChargeDate = function(date) {
    if (date) {
        return moment(date).format('D/MM/YYYY')
    } else {
        return moment().format('D/MM/YYYY')
    }
}

/**
 * 
 */
export default async id => {

    //
    let banks = await fetchBank()
    let body4Height = 0

    //
    const customerReceivablePayment     = await CustomerReceivablePaymentService.fetchById( id )
        , paymentVerifyId               = customerReceivablePayment.id || ''
        , receivablePaymentBusinessName = customerReceivablePayment.sl_customer.business_name || ''
        , receivablePaymentCreated      = customerReceivablePayment.created_at || ''
        , receivablePaymentInvoices     = customerReceivablePayment.pos_detail_customer_receivable_payments || []
        , receivablePaymentRut          = customerReceivablePayment.sl_customer.rut || ''
        , receivablePayments            = customerReceivablePayment.transformed_payments || []
        , body1Height                   = receivablePaymentInvoices.length * 15
        , body2Height                   = receivablePayments.length * 15
        , signHeight                    = 225

    //
    
    //
    console.log( body1Height, body2Height, signHeight )    
    
    //    
    var doc = new jsPDF({ putOnlyUsedFonts: true, format: 'letter' }), 
        body = [],
        body2 = [],
        body3 = [], //rounding
        body4 = [] //detalle

    //
    receivablePaymentInvoices.forEach( detail => {

        //
        body.push([             
            detail.sl_customer_receivable.sl_customer_branch_offices ?
                detail.sl_customer_receivable.sl_customer_branch_offices.address
                :
                '-',
            detail.sl_customer_receivable.sl_sale_invoice ? 
                detail.sl_customer_receivable.sl_sale_invoice.number
                :
                detail.sl_customer_receivable.sl_sale_debit_note ?
                    detail.sl_customer_receivable.sl_sale_debit_note.number
                    :
                    '-',
            detail.sl_customer_receivable.sl_sale_invoice ? 
                `$ ${Number(detail.sl_customer_receivable.sl_sale_invoice.total).toFixed( 0 )}`
                :
                detail.sl_customer_receivable.sl_sale_debit_note ?
                    `$ ${Number(detail.sl_customer_receivable.sl_sale_debit_note.total).toFixed( 0 )}`
                    :
                    '-',
        ])
    })
    
    //
    receivablePayments.forEach( payment => {

        //
        const { data: pivotData } = payment.pivot

        //
        if (payment.type == 'Cheque') {
            body4.push([
                getTypeCheck(pivotData.pos_payment_check_type_id),
                searchBankName(banks, pivotData.g_bank_id),
                pivotData.account_number,
                pivotData.serial_number,
                setChargeDate(pivotData.charge_date),
                CurrencyUtils.filters.mixFormatCurrency(payment.pivot.amount),
            ])
            body4Height += 30
        }

        //
        body2.push([
            payment.type,
            moment( payment.created_at ).format( 'D/MM/YYYY' ),
            '$' + payment.pivot.amount,
        ])
    })
    
    //
    //doc.setFontStyle( 'bold' )
    doc.text( 'COMPROBANTE DE PAGO', 16, 20 )
    //doc.setTextColor( '#087f23' )
    doc.text( '# ' + paymentVerifyId, 16, 28 )
    doc.setFontSize( 12 );
    doc.setFontStyle( 'normal' )
    doc.setTextColor( '#000' )

    //
    doc.text( 'RUT DEL CLIENTE:', 16, 42 )
    //doc.setFontStyle( 'bold' )
    doc.text( receivablePaymentRut, 56, 42 )
    doc.setFontStyle( 'normal' )

    //
    doc.text( 'FECHA:', 242, 42 )
    //doc.setFontStyle( 'bold' )
    doc.text( moment( receivablePaymentCreated ).format( 'D/MM/YYYY' ), 260, 42 )
    doc.setFontStyle( 'normal' )

    //
    doc.text( 'NOMBRE DEL CLIENTE:', 16, 50 )
    //doc.setFontStyle( 'bold' )
    doc.text( receivablePaymentBusinessName, 66, 50 )
    doc.setFontStyle( 'normal' )

    //
    //doc.text( 'CÓDIGO DE CLIENTE:', 200, 50 )
    //doc.setFontStyle( 'bold' )
    //doc.text( paymentVerifyRut, 247, 50 )
    //doc.setFontStyle( 'normal' )

    //
    //doc.text( 'EFECTIVO $', 16, 58 )
    //doc.setFontStyle( 'bold' )
    //doc.text( paymentVerifyAmount, 44, 58 )
    //doc.setFontStyle( 'normal' )

    //
    doc.autoTable({
        head: [
            [ { colSpan: 5, content: 'DETALLE DE FACTURAS A CANCELAR' } ],
            [ 'SUCURSAL',  'N° DE DOCUMENTO', { content: 'MONTO', halign: 'right' } ],
        ],
        columnStyles: {
            0: { cellWidth: 30 },
            1: { cellWidth: 40 },
            2: { cellWidth: 30, halign: 'right' },
        },
        headStyles: {
            fillColor: '#fff',
            fontSize: 12,
            fontStyle: 'normal',
            //lineColor: '#000',
            lineWidth: 0.25,
            textColor: '#000',
        },
        body,
        bodyStyles: {
            fontSize: 12,
            textColor: '#000',
        },
        theme: 'grid',
        startX: 66,
        startY: 62,
    })
    
    //
    doc.autoTable({
        head: [
            [ { colSpan: 2, content: 'DETALLE DE PAGOS REALIZADOS' } ],
            [ 'TIPO', 'FECHA', { content: 'MONTO', halign: 'right' } ],
        ],
        columnStyles: {
            0: { cellWidth: 40 },
            1: { cellWidth: 30 },
            2: { cellWidth: 30, halign: 'right' },
        },
        headStyles: {
            fillColor: '#fff',
            fontSize: 12,
            fontStyle: 'normal',
            //lineColor: '#000',
            lineWidth: 0.25,
            textColor: '#000',
        },
        body: body2,
        bodyStyles: {
            fontSize: 12,
            textColor: '#000',
        },
        theme: 'grid',
        startX: 66,
        startY: 66 + body1Height + 16,
    })

    if(body4.length >0){

        doc.autoTable({
            head: [
                [{ colSpan: 2, content: 'DETALLE PAGO CON CHEQUE' }],
                [
                    'TIPO',
                    'BANCO',
                    'CUENTA',
                    'N Documento',
                    'Fecha Pago',
                    { content: 'MONTO PAGADO', halign: 'right' },
                ],
            ],
            columnStyles: {
                0: { cellWidth: 20 },
                1: { cellWidth: 20 },
                2: { cellWidth: 20 },
                3: { cellWidth: 10 },
                4: { cellWidth: 10 },
                5: { cellWidth: 20, halign: 'right' },
            },
            headStyles: {
                fillColor: '#fff',
                fontSize: 12,
                fontStyle: 'normal',
                //lineColor: '#2196F3',
                lineWidth: 0.25,
                textColor: '#000',
            },
            body: body4,
            bodyStyles: {
                fontSize: 12,
                textColor: '#000',
            },
            theme: 'grid',
            startX: 66,
            startY: 66 + body1Height + body2Height + 32,
        })
    }

    //
    doc.setFontStyle( 'bold' )
    doc.text( 'FIRMA Y TIMBRE', 140, 66 + body1Height + body2Height + body4Height + 48 )

    //
    doc.save( [ 'comprobante-pago-' + id + '.pdf' ].join( '' ) )
}